import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 420px;

  > div {
    align-items: center;
  }

  > div:nth-of-type(1) {
    cursor: pointer;
  }

  @media (max-width: 1260px) {
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
  }
`;

export const Row = styled.div`
  display: flex;
`;

export const AddButton = styled.div`
  cursor: pointer;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #61e171;
  text-align: center;

  > span {
    display: block;
    font-family: 'Aller-Light';
    font-size: 3rem;
    color: #fff;
    margin-left: -4px;
    margin-top: -3px;
  }
`;

export const AddCard = styled.span`
  font-family: 'Aller-Regular';
  font-size: 1.4rem;
  color: #165011;
  margin-left: 10px;
`;

export const Informations = styled.div`
  width: 400px;
  height: 260px;
  border-radius: 20px;
  background-color: ${(props) =>
    props.creditCardBannerSelected ? '#61E171' : '#E2E2E2'};
  margin-top: 40px;
  padding: 20px;
  transition: 1s all;

  > div > div {
    height: 40px;
    border-radius: 12px;
    padding: 2px;
    > input {
      background-color: #fff;
      text-align: center;
      border-radius: 12px;
    }
  }

  > div:nth-of-type(1) {
    justify-content: flex-end;
    > div {
      width: 40%;
    }
  }

  > div:nth-of-type(2) {
    justify-content: space-between;
    > div {
      width: 22%;
    }
  }

  > div:nth-of-type(3) {
    justify-content: space-between;
    > div:nth-of-type(1) {
      width: 50%;
      height: 32px;
    }
    > div:nth-of-type(2) {
      width: 30%;
      height: 32px;
    }
  }

  img {
    height: 40px;
    margin-bottom: 40px;
  }

  @media (max-width: 1080px) {
    width: 360px;
    height: 240px;
    padding: 10px;
  }

  @media (max-width: 1260px) {
    width: 100%;

    > div:nth-of-type(2) {
      > div {
        padding: 0 4px;
      }
    }

    > div:nth-of-type(3) {
      > div:nth-of-type(1) {
        padding: 0 4px;
      }
      > div:nth-of-type(2) {
        padding: 0 4px;
      }
    }
  }
`;
